import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import * as PermissionStateActions from './permission-state.actions';
import * as PermissionStateSelectors from './permission-state.selectors';
import { ModulePermission } from './permission-state.model';
import { FeaturesEnum } from '@core/models/enums';
import { map, Observable } from 'rxjs';
import { FeaturePermissions, PermissionEnumKey } from '@core/feature-permission.map';

@Injectable({
    providedIn: 'root',
})
export class PermissionStateFacade {
    pagePermissions$ = this.store$.pipe(select(PermissionStateSelectors.pagePermissionsSelector));
    error$ = this.store$.pipe(select(PermissionStateSelectors.errorSelector));

    constructor(private readonly store$: Store) { }

    setPagePermissions(pagePermissions: ModulePermission[]): void {
        this.store$.dispatch(PermissionStateActions.setPagePermissions({ pagePermissions }));
    }

    getCurrentPagePermissions(): Observable<ModulePermission[]> {
        return this.pagePermissions$.pipe(
            map(permissions => permissions)
        );
    }

    hasPermission(feature: FeaturesEnum, requiredPermission: string): Observable<boolean> {
        return this.pagePermissions$.pipe(
            map(permissions => {
                const featurePermission = permissions.find((x) => x.accessKey === feature);
                if (!featurePermission) return false;

                return featurePermission.permissions.includes(requiredPermission);
            })
        );
    }

    loadPermissions(): void {
        this.store$.dispatch(PermissionStateActions.loadPermissions());
    }

    resetPermissionState(): void {
        this.store$.dispatch(PermissionStateActions.resetPermissionState());
    }
}
